export const isBlank = (s: string): boolean => s === '';

export {
  buttonTarget,
  inputTarget,
  textareaTarget,
  selectTarget,
  eventTargetValue
} from 'common/eventTargets';

export { pricesToText } from 'packages/utils/pricing/pricesToText';
export { vatText } from 'packages/utils/pricing/vatText';
